export const SET_CURRENT_SECTION = "setCurrentSection";
export const SET_ANSWER = "setAnswer";
export const REFRESH_STATE = "refreshState";
export const RESTART_SURVEY = "restartSurvey";
export const CONFIRM_WELCOME = "confirmWelcome";

// For testing
export const RESET_STATE = "resetState";
